import React, { useState, useEffect } from 'react';
import Sidebar from '../../components/Admin/Sidebar';
import useScheduleStore from '../../stores/scheduleStore';
import { getWeeks } from '../../api';
import AdminScheduleModal from '../../components/Admin/AdminScheduleModal';
import AdminSlotDetailsModal from '../../components/Admin/AdminSlotDetailsModal';
import AdminBottomNavBar from '../../components/Admin/AdminBottomNavBar';

const days = ['Понедельник','Вторник','Среда','Четверг','Пятница','Суббота','Воскресенье'];
const displayDays = ['Пн','Вт','Ср','Чт','Пт','Сб','Вс'];

// Функции для работы с месяцами (копируем из AdminSchedule)
const getMonthsList = () => {
  const months = [];
  const now = new Date();
  
  for (let i = -2; i <= 12; i++) {
    const date = new Date(now.getFullYear(), now.getMonth() + i, 1);
    months.push({
      value: `${date.getFullYear()}-${String(date.getMonth() + 1).padStart(2, '0')}`,
      label: date.toLocaleDateString('ru-RU', { month: 'long', year: 'numeric' }),
      year: date.getFullYear(),
      month: date.getMonth() + 1
    });
  }
  return months;
};

const getWeeksInMonth = (year, month) => {
  const weeks = [];
  const firstDay = new Date(year, month - 1, 1);
  const lastDay = new Date(year, month, 0);
  
  const startDate = new Date(firstDay);
  const dayOfWeek = startDate.getDay();
  const daysToSubtract = dayOfWeek === 0 ? 6 : dayOfWeek - 1;
  startDate.setDate(startDate.getDate() - daysToSubtract);
  
  let currentWeekStart = new Date(startDate);
  
  while (currentWeekStart <= lastDay) {
    const weekEnd = new Date(currentWeekStart);
    weekEnd.setDate(weekEnd.getDate() + 6);
    
          const weekDates = Array.from({ length: 7 }, (_, i) => {
        const date = new Date(currentWeekStart);
        date.setDate(currentWeekStart.getDate() + i);
        return date;
      });
      
      console.log('[AdminRasp] Неделя дат:', weekDates.map(d => d.toISOString().slice(0, 10)));
      
      weeks.push({
        start: new Date(currentWeekStart),
        end: new Date(weekEnd),
        dates: weekDates
      });
    
    currentWeekStart.setDate(currentWeekStart.getDate() + 7);
  }
  
  return weeks;
};

const getWeekNumber = (date) => {
  const d = new Date(Date.UTC(date.getFullYear(), date.getMonth(), date.getDate()));
  const dayNum = d.getUTCDay() || 7;
  d.setUTCDate(d.getUTCDate() + 4 - dayNum);
  const yearStart = new Date(Date.UTC(d.getUTCFullYear(), 0, 1));
  return Math.ceil((((d - yearStart) / 86400000) + 1) / 7);
};

function AdminRasp() {
  const { fetchAllSchedulesForWeek, allSchedules, loading, saveGroupSchedule, saveStudentSchedule, deleteGroupSchedule, deleteStudentSchedule } = useScheduleStore();
  const [selectedMonth, setSelectedMonth] = useState(() => {
    const now = new Date();
    return `${now.getFullYear()}-${String(now.getMonth() + 1).padStart(2, '0')}`;
  });
  const [monthlySchedule, setMonthlySchedule] = useState([]);
  const [months] = useState(getMonthsList());
  const [modal, setModal] = useState({ open: false, dayIdx: null, weekIdx: null });
  const [editModal, setEditModal] = useState({ open: false, dayIdx: null, weekIdx: null, slot: null });
  const [details, setDetails] = useState({ open: false, slot: null });

  // Получаем недели выбранного месяца
  const selectedMonthData = months.find(m => m.value === selectedMonth);
  const weeksInMonth = selectedMonthData ? getWeeksInMonth(selectedMonthData.year, selectedMonthData.month) : [];

  // Загрузка расписания за месяц (переиспользуемая функция)
  const loadMonthlySchedule = async () => {
    if (!selectedMonthData) return;
    const monthData = [];
    for (let weekIdx = 0; weekIdx < weeksInMonth.length; weekIdx++) {
      const weekData = Array.from({ length: 7 }, () => []);
      const weekStart = weeksInMonth[weekIdx].start;
      const weekNumber = getWeekNumber(weekStart);
      try {
        const weekEnd = new Date(weekStart);
        weekEnd.setDate(weekStart.getDate() + 6);
        const startDateStr = weekStart.toISOString().slice(0, 10);
        const endDateStr = weekEnd.toISOString().slice(0, 10);
        const scheduleData = await fetchAllSchedulesForWeek({ startDate: startDateStr, endDate: endDateStr });
        (scheduleData || []).forEach(day => {
          const dayIdx = days.indexOf(day.dayOfWeek);
          if (dayIdx !== -1) {
            const weekDayDate = new Date(weekStart);
            weekDayDate.setDate(weekStart.getDate() + dayIdx);
            const expectedDate = weekDayDate.toISOString().slice(0, 10);
            if (day.date === expectedDate || !day.date) {
              (day.timeSlots || []).forEach((slot, idx) => {
                weekData[dayIdx].push({
                  ...slot,
                  group: day.group,
                  student: day.student,
                  scheduleId: day._id,
                  groupId: day.group?._id || day.group,
                  date: day.date || expectedDate,
                  slotIndex: typeof slot.slotIndex === 'number' ? slot.slotIndex : idx
                });
              });
              weekData[dayIdx].sort((a, b) => {
                const timeA = a.startTime || '00:00';
                const timeB = b.startTime || '00:00';
                return timeA.localeCompare(timeB);
              });
            }
          }
        });
      } catch (error) {
        console.error('Ошибка загрузки расписания для недели', weekNumber, error);
      }
      monthData.push(weekData);
    }
    setMonthlySchedule(monthData);
  };

  useEffect(() => {
    loadMonthlySchedule();
  }, [selectedMonth, selectedMonthData, weeksInMonth.length]);



  const handleAddSlot = (dayIdx, weekIdx) => {
    setModal({ open: true, dayIdx, weekIdx, freeTime: true });
  };

  const EMPTY_SLOT = { startTime: '', endTime: '', subject: null, comment: '' };

  const handleSaveSlot = async ({ groupId, studentId, subjectId, comment, slotTime, duration = 1, students, customStartTime, customEndTime }) => {
    const weekIdx = modal.weekIdx;
    const weekStart = weeksInMonth[weekIdx]?.start;
    
    if (!weekStart) {
      alert('Ошибка: неверная неделя');
      return;
    }
    
    // Вычисляем конкретную дату для дня  
    const week_dates = weeksInMonth[weekIdx];
    if (!week_dates || !week_dates.dates || !week_dates.dates[modal.dayIdx]) {
      alert('Ошибка: не удалось определить дату');
      return;
    }
    const currentDate = week_dates.dates[modal.dayIdx];
    const dateStr = currentDate.toISOString().slice(0, 10);
    console.log('[AdminRasp SAVE] Текущая дата из календаря:', {
      weekIdx,
      dayIdx: modal.dayIdx,
      currentDate: currentDate.toISOString(),
      dateStr
    });
    
    const week = getWeekNumber(weekStart);
    const dayOfWeek = days[modal.dayIdx];
    const startTime = customStartTime;
    const endTime = customEndTime;
    
    if (!startTime || !endTime) {
      alert('Пожалуйста, укажите время начала и окончания занятия');
      return;
    }
    const daySchedules = (allSchedules || []).filter(s => s.dayOfWeek === dayOfWeek && s.week === week);
    let timeSlotsArr = [];
    if (studentId) {
      const ind = daySchedules.find(s => s.student && s.student._id === studentId);
      if (ind && Array.isArray(ind.timeSlots)) {
        timeSlotsArr = ind.timeSlots.filter(Boolean);
      }
    } else if (groupId) {
      const group = daySchedules.find(s => s.group && s.group._id === groupId);
      if (group && Array.isArray(group.timeSlots)) {
        timeSlotsArr = group.timeSlots.filter(Boolean);
      }
    }
    // Удаляем старый слот с этим временем
    timeSlotsArr = timeSlotsArr.filter(
      slot => !(slot.startTime === startTime && slot.endTime === endTime)
    );
    // Добавляем новый/отредактированный слот
    timeSlotsArr.push({ startTime, endTime, subject: subjectId, comment });
    if (Array.isArray(students) && students.length && groupId && !studentId) {
      // Групповое расписание: сохранить с выбранными учениками
      await saveGroupSchedule({ groupId, week, dayOfWeek, date: dateStr, timeSlots: timeSlotsArr, students });
    } else if (Array.isArray(students) && students.length && studentId) {
      // Массовое индивидуальное: сохранить каждому выбранному
      for (const sid of students) {
        await saveStudentSchedule({ studentId: sid, week, dayOfWeek, date: dateStr, timeSlots: timeSlotsArr });
      }
    } else if (Array.isArray(students) && students.length && !groupId && !studentId) {
      // Общая страница: выбраны только ученики — создаём индивидуальные слоты каждому
      for (const sid of students) {
        await saveStudentSchedule({ studentId: sid, week, dayOfWeek, date: dateStr, timeSlots: timeSlotsArr });
      }
    } else if (studentId) {
      await saveStudentSchedule({ studentId, week, dayOfWeek, date: dateStr, timeSlots: timeSlotsArr });
    } else if (groupId) {
      console.log('[AdminRasp SAVE] Групповое занятие с датой:', dateStr);
      await saveGroupSchedule({ groupId, week, dayOfWeek, date: dateStr, timeSlots: timeSlotsArr });
    }
    // Перезагружаем данные с сервера, чтобы появились названия предметов/групп
    await loadMonthlySchedule();

    setModal({ open: false, dayIdx: null, weekIdx: null });
  };

  const handleEditSlot = (dayIdx, slot, weekIdx) => {
    setEditModal({ open: true, dayIdx, weekIdx, slot, freeTime: true });
  };

  const handleSaveEditSlot = async ({ groupId, studentId, subjectId, comment, customStartTime, customEndTime, students }) => {
    const weekIdx = editModal.weekIdx;
    const weekStart = weeksInMonth[weekIdx]?.start;
    
    if (!weekStart) {
      alert('Ошибка: неверная неделя');
      return;
    }
    
    // Вычисляем конкретную дату для дня
    const week_dates = weeksInMonth[weekIdx];
    if (!week_dates || !week_dates.dates || !week_dates.dates[editModal.dayIdx]) {
      alert('Ошибка: не удалось определить дату');
      return;
    }
    const currentDate = week_dates.dates[editModal.dayIdx];
    const dateStr = currentDate.toISOString().slice(0, 10);
    console.log('[AdminRasp EDIT] Текущая дата из календаря:', {
      weekIdx,
      dayIdx: editModal.dayIdx,
      currentDate: currentDate.toISOString(),
      dateStr
    });
    
    const week = getWeekNumber(weekStart);
    const dayOfWeek = days[editModal.dayIdx];
    const startTime = customStartTime;
    const endTime = customEndTime;
    
    if (!startTime || !endTime) {
      alert('Пожалуйста, укажите время начала и окончания занятия');
      return;
    }
    const daySchedules = (allSchedules || []).filter(s => s.dayOfWeek === dayOfWeek && s.week === week);
    let timeSlotsArr = [];
    if (studentId) {
      const ind = daySchedules.find(s => s.student && s.student._id === studentId);
      if (ind && Array.isArray(ind.timeSlots)) {
        timeSlotsArr = ind.timeSlots.filter(Boolean);
      }
    } else if (groupId) {
      const group = daySchedules.find(s => s.group && s.group._id === groupId);
      if (group && Array.isArray(group.timeSlots)) {
        timeSlotsArr = group.timeSlots.filter(Boolean);
      }
    }
    // Удаляем старый слот с исходным временем
    const originalSlot = editModal.slot;
    timeSlotsArr = timeSlotsArr.filter(
      slot => !(slot.startTime === originalSlot.startTime && slot.endTime === originalSlot.endTime)
    );
    // Добавляем новый/отредактированный слот
    timeSlotsArr.push({ startTime, endTime, subject: subjectId, comment });
    
    if (Array.isArray(students) && students.length && groupId && !studentId) {
      await saveGroupSchedule({ groupId, week, dayOfWeek, date: dateStr, timeSlots: timeSlotsArr, students });
    } else if (Array.isArray(students) && students.length && !groupId && !studentId) {
      for (const sid of students) {
        await saveStudentSchedule({ studentId: sid, week, dayOfWeek, date: dateStr, timeSlots: timeSlotsArr });
      }
    } else if (studentId) {
      await saveStudentSchedule({ studentId, week, dayOfWeek, date: dateStr, timeSlots: timeSlotsArr });
    } else if (groupId) {
      console.log('[AdminRasp EDIT] Редактируем групповое занятие с датой:', dateStr);
      await saveGroupSchedule({ groupId, week, dayOfWeek, date: dateStr, timeSlots: timeSlotsArr });
    }
    await loadMonthlySchedule();

    setEditModal({ open: false, dayIdx: null, weekIdx: null, slot: null });
  };

  const handleDeleteSlot = async (dayIdx, weekIdx, slotToDelete = null) => {
    const slot = slotToDelete;
    if (!slot) return;
    if (!window.confirm('Удалить это занятие?')) return;
    
    const weekStart = weeksInMonth[weekIdx]?.start;
    if (!weekStart) return;
    
    // Вычисляем конкретную дату для дня
    const week_dates = weeksInMonth[weekIdx];
    if (!week_dates || !week_dates.dates || !week_dates.dates[dayIdx]) {
      alert('Ошибка: не удалось определить дату');
      return;
    }
    const currentDate = week_dates.dates[dayIdx];
    const dateStr = currentDate.toISOString().slice(0, 10);
    console.log('[AdminRasp DELETE] Текущая дата из календаря:', {
      weekIdx,
      dayIdx,
      currentDate: currentDate.toISOString(),
      dateStr
    });
    
    const week = getWeekNumber(weekStart);
    const dayOfWeek = days[dayIdx];
    const startTime = slot.startTime;
    const endTime = slot.endTime;
    if (slot.student && slot.student._id) {
      await deleteStudentSchedule({ studentId: slot.student._id, week, dayOfWeek, date: dateStr, startTime, endTime });
    } else if (slot.group && slot.group._id) {
      // Используем новый API для удаления конкретного слота
      await deleteGroupSchedule({ groupId: slot.group._id, week, dayOfWeek, date: dateStr, startTime, endTime });
    } else {
      alert('Удаление невозможно: слот не привязан к этому ученику или группе.');
      return;
    }
    
    await loadMonthlySchedule();
  };

  return (
    <div className='AdminRasp'>
        <div className="AdminRasp__container" style={{ display: 'flex' }}>
            <Sidebar />
            <div className="content_admin" style={{ marginLeft: 240, width: '100%', overflowX: 'auto', minHeight: '100vh', position: 'relative' }}>
                {/* Тень справа от Sidebar */}
                <div className="adminrasp-gradient-shadow" style={{ position: 'fixed', left: 200, top: 0, width: 16, height: '100vh', zIndex: 11, pointerEvents: 'none' }} />
                <div style={{ display: 'flex', gap: 12, marginBottom: 24, alignItems: 'center' }}>
                  <span style={{ fontWeight: 500 }}>Месяц:</span>
                  <select value={selectedMonth} onChange={e => setSelectedMonth(e.target.value)} style={{ padding: '6px 12px', borderRadius: 6, border: '1px solid #ccc' }}>
                    {months.map((month) => (
                      <option value={month.value} key={month.value}>{month.label}</option>
                    ))}
                  </select>
                </div>
                <div className='AdminRasp-monthly'>
                  {weeksInMonth.map((week, weekIdx) => (
                    <div key={weekIdx} className='monthly-week' style={{ marginBottom: 30 }}>
                      <div className='week-header' style={{ fontSize: 14, color: '#666', marginBottom: 10, textAlign: 'center' }}>
                        Неделя {week.start.getDate()}.{String(week.start.getMonth() + 1).padStart(2, '0')} - {week.end.getDate()}.{String(week.end.getMonth() + 1).padStart(2, '0')}
                      </div>
                      <div className='AdminSchedule-kanban' style={{ display: 'flex', gap: 15 }}>
                        {displayDays.map((day, dayIdx) => {
                          const currentDate = week.dates[dayIdx];
                          const isCurrentMonth = currentDate.getMonth() === selectedMonthData?.month - 1;
                          
                          return (
                            <div className='Schedule__column' key={dayIdx} style={{ 
                              flex: 1, 
                              opacity: isCurrentMonth ? 1 : 0.3,
                              minHeight: 200
                            }}>
                              <div className='title' style={{ 
                                fontSize: 13, 
                                marginBottom: 8,
                                color: isCurrentMonth ? '#333' : '#999',
                                textAlign: 'center'
                              }}>
                                {day} {currentDate.getDate()}.{String(currentDate.getMonth() + 1).padStart(2, '0')}
                              </div>
                              
                              {/* Отображаем только добавленные занятия */}
                              {(() => {
                                const daySlots = monthlySchedule[weekIdx]?.[dayIdx] || [];
                                return daySlots;
                              })().map((slot, slotIdx) => (
                                <div className='ScheduleBlock filled' key={slotIdx} style={{ marginBottom: 8, background: '#fff', borderRadius: 8, boxShadow: '0 1px 4px #ece9f7', padding: 10, fontSize: 14 }}>
                                  <div style={{ marginBottom: 4 }}>
                                    <div style={{ color: '#6c3be4', fontWeight: 700, fontSize: 15, marginBottom: 4 }}>
                                      {slot.startTime}
                                      {slot.endTime ? `–${slot.endTime}` : ''}
                                    </div>
                                    <div style={{ fontSize: 13, color: '#222', marginBottom: 2 }}>
                                      {slot.group ? `Группа: ${slot.group.name}` : slot.student ? `Ученик: ${slot.student.fullName}` : ''}
                                    </div>
                                    <div style={{ fontSize: 13, color: '#222', marginTop: 2 }}>Предмет: {slot.subject?.name || slot.subject}</div>
                                    {slot.comment && <div style={{ fontSize: 12, color: '#888', marginTop: 2 }}>Комментарий: {slot.comment}</div>}
                                    <div style={{ display: 'flex', flexDirection: 'column', gap: 6, marginTop: 8 }}>
                                      <button style={{ border: '1px solid #6c3be4', color: '#6c3be4', borderRadius: 6, padding: '6px 10px', fontSize: 12, background: 'none', cursor: 'pointer', width: '100%' }} onClick={() => handleEditSlot(dayIdx, slot, weekIdx)}>Ред.</button>
                                      <button style={{ border: '1px solid #6c3be4', color: '#fff', background: '#6c3be4', borderRadius: 6, padding: '6px 10px', fontSize: 12, cursor: 'pointer', width: '100%' }} onClick={() => setDetails({ open: true, slot })}>Подр.</button>
                                      <button style={{ border: '1px solid #e74c3c', color: '#fff', background: '#e74c3c', borderRadius: 6, padding: '6px 10px', fontSize: 12, cursor: 'pointer', width: '100%' }} onClick={() => handleDeleteSlot(dayIdx, weekIdx, slot)}>Удал.</button>
                                    </div>
                                  </div>
                                </div>
                              ))}

                              {/* Плюсик для добавления нового занятия */}
                              {isCurrentMonth && (
                                <div className='ScheduleBlock empty' style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', minHeight: 60, background: '#f5f5f5', borderRadius: 8, marginBottom: 8 }}>
                                  <button className="add-slot-btn" style={{ fontSize: 20, color: '#6c3be4', background: 'none', border: 'none', cursor: 'pointer' }} onClick={() => handleAddSlot(dayIdx, weekIdx)}>+</button>
                            </div>
                              )}
                          </div>
                        );
                      })}
                      </div>
                    </div>
                  ))}
                </div>
                <AdminScheduleModal
                  open={modal.open}
                  onClose={() => setModal({ open: false, dayIdx: null, weekIdx: null })}
                  onSave={handleSaveSlot}
                  initialData={{}}
                  freeTime={modal.freeTime}
                />
                <AdminScheduleModal
                  open={editModal.open}
                  onClose={() => setEditModal({ open: false, dayIdx: null, weekIdx: null, slot: null })}
                  onSave={handleSaveEditSlot}
                  initialData={editModal.slot}
                  freeTime={editModal.freeTime}
                />
                <AdminSlotDetailsModal
                  open={details.open}
                  onClose={() => setDetails({ open: false, slot: null })}
                  slot={details.slot}
                />
            </div>
        </div>
        <AdminBottomNavBar />
    </div>
  );
}

export default AdminRasp;